import { render, staticRenderFns } from "./Understand.vue?vue&type=template&id=fcb0e380"
import script from "./Understand.vue?vue&type=script&lang=js"
export * from "./Understand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports